document.addEventListener("DOMContentLoaded", () => {
  const tabTitles = document.querySelectorAll(".tab-titles li");
  const tabPanels = document.querySelectorAll(".tab-panel");

  tabTitles.forEach((tab) => {
    tab.addEventListener("click", () => {
      // Remove the 'active' class from all tabs and panels
      tabTitles.forEach((t) => t.classList.remove("active"));
      tabPanels.forEach((panel) => panel.classList.remove("active"));

      // Add the 'active' class to the clicked tab and corresponding panel
      tab.classList.add("active");
      const targetTab = tab.getAttribute("data-tab");
      document
        .querySelector(`.tab-panel[data-tab="${targetTab}"]`)
        .classList.add("active");
    });
  });
});

// Swiper
let swiperBest;

function handleSwiper() {
  const isMobileOrTablet = window.innerWidth <= 1024;

  if (isMobileOrTablet && !swiperBest) {
    // Initialize Swiper
    swiperBest = new Swiper(".swiper-best", {
      loop: true,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: ".best-next",
        prevEl: ".best-prev",
      },
    });
  } else if (!isMobileOrTablet && swiperBest) {
    // Destroy Swiper if initialized
    swiperBest.destroy(true, true);
    swiperBest = null;
  }
}

// Run on page load
document.addEventListener("DOMContentLoaded", () => {
  handleSwiper();

  // Add a resize event listener
  window.addEventListener("resize", handleSwiper);
});
